module.exports = __webpack_public_path__ + "img/work-sans-v4-latin-ext-500.1a993836.svg";